import { COLORS } from '../constants.js';

// Y-axis tick callback - shows "Days" only on the last tick
export const yAxisTickCallback = (value, index, ticks) => {
  if (index === ticks.length - 1) return 'Days';
  return value;
};

// Y-axis font callback - makes the last tick (Days) bold
export const yAxisFontCallback = function (context) {
  if (!context.chart.scales.y || !context.chart.scales.y.ticks) return;

  if (context.index === context.chart.scales.y.ticks.length - 1) {
    return {
      weight: 500,
    };
  }
};

// Y-axis afterDataLimits callback - adds padding to max value
export const yAxisAfterDataLimits = (scale) => {
  scale.max = scale.max + 2;
};

// Y-axis afterFit callback - sets explicit width for y-axis
export const yAxisAfterFit = (axis) => {
  axis.width = 33; // Explicitly set a width to ensure sufficient space
};

export const createScalesConfig = (maxYScale) => ({
  x: {
    grid: {
      display: false,
      tickLength: 3,
    },
    ticks: {
      autoSkip: false,
      maxRotation: 0,
      color: COLORS.secondaryText,
      align: 'start',
      padding: 0,
      labelOffset: 4,
    },
    border: {
      display: true,
      color: COLORS.axisStroke,
      width: 1,
      z: 1,
    },
    offset: false,
  },
  y: {
    display: true,
    grid: {
      display: true,
      drawOnChartArea: false,
      drawTicks: true,
      color: COLORS.axisStroke,
      tickLength: 5,
    },
    title: {
      display: false,
    },
    border: {
      display: true,
      color: COLORS.axisStroke,
      width: 1,
    },
    ticks: {
      count: 6,
      color: COLORS.secondaryText,
      align: 'end',
      padding: 0,
      labelOffset: -3,
      callback: yAxisTickCallback,
      font: yAxisFontCallback,
    },
    suggestedMin: 0,
    max: maxYScale,
    afterDataLimits: yAxisAfterDataLimits,
    afterFit: yAxisAfterFit,
  },
});
